// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__Z3MWK","label":"styles_label__6sOQl","icon":"styles_icon__jI6MG"};